import React, { ReactNode } from 'react'
import { Text, Popover, Flex } from 'components/ds'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from 'components/ui/icon/svg-icons'
import cn from 'clsx'
import styles from './switcher-popover-content.module.css'
import { TextProps } from '@radix-ui/themes'

export function SwitcherPopoverContentLink({
  title,
  subtitle,
  isSelected,
  to,
  isExternal,
  hasExternalLinkIcon,
  textColor,
  href,
  leftNode,
  className,
  testId,
  onClick,
}: {
  title
  subtitle?: string
  to?: string
  isSelected?: boolean
  isExternal?: boolean
  hasExternalLinkIcon?: boolean
  textColor?: TextProps['color']
  href?: string
  leftNode?: ReactNode
  className?: string
  testId?: string
  onClick?: () => void
}) {
  const linkProps = {
    className: cn(
      styles['switcher-popover-content-link'],
      isSelected && styles['switcher-popover-content-link--selected'],
      className,
    ),
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noopener noreferrer' : undefined,
    onClick,
  }

  const linkContent = (
    <>
      {leftNode}
      <Flex direction="column" gap="2px" minWidth="0">
        <Text
          size="2"
          color={textColor}
          className={styles['switcher-popover-content-link-text-overflow']}
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            className={styles['switcher-popover-content-link-text-overflow']}
            size="1"
            color="gray"
          >
            {subtitle}
          </Text>
        )}
      </Flex>
      {hasExternalLinkIcon && <ExternalLinkIcon size={16} />}
    </>
  )

  return (
    <Popover.Close data-testid={testId}>
      {isExternal || href ? (
        <a {...linkProps} href={href}>
          {linkContent}
        </a>
      ) : (
        <Link {...linkProps} to={to || '#'}>
          {linkContent}
        </Link>
      )}
    </Popover.Close>
  )
}
